module.exports = __webpack_public_path__ + "img/ic_liquid.ba8207e7.svg";